import { render, staticRenderFns } from "./MortalDetails.vue?vue&type=template&id=b661b1fa&scoped=true"
import script from "./MortalDetails.vue?vue&type=script&lang=js"
export * from "./MortalDetails.vue?vue&type=script&lang=js"
import style0 from "./MortalDetails.vue?vue&type=style&index=0&id=b661b1fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b661b1fa",
  null
  
)

export default component.exports